import { HOTEL_SEARCHBOX_CONFIG } from '@/config';
import React, { Ref } from 'react';
import DatePicker from 'react-multi-date-picker';

export interface DateSearchBoxProps {
  from: Date | null | undefined;
  to: Date | null | undefined;
  elmRef: Ref<{ close: Function; open: Function; getDates: () => [Date | undefined, Date | undefined] } | undefined>;
  closeAndNext: () => void;
  onDatesChange: (dates: any) => void;
}
const DateSearch = ({ from, to, elmRef, closeAndNext, onDatesChange }: DateSearchBoxProps) => {
  const ref = React.useRef<any>();

  React.useImperativeHandle(
    elmRef,
    () => {
      return {
        open() {
          ref.current?.openCalendar();
        },
        close() {
          ref.current?.closeCalendar();
        },
        getDates() {
          return [new Date(), new Date()];
        },
      };
    },
    [ref],
  );
  const onChange = (dates: any[]) => {
    if (dates.length === 2 && dates[0] && dates[1]) {
      closeAndNext();
    }
    onDatesChange(dates);
  };
  const values: any = React.useMemo(() => {
    return [from, to];
  }, [from, to]);
  return (
    <div className="text-15 text-light-1 ls-2 lh-16 custom_dual_datepicker">
      <DatePicker
        ref={ref}
        arrowStyle={{ display: 'none' }}
        inputClass="custom_input-picker"
        containerClassName="custom_container-picker"
        value={values}
        numberOfMonths={2}
        offsetY={10}
        onChange={onChange}
        range
        rangeHover
        format="MMM DD"
        editable={false}
        minDate={HOTEL_SEARCHBOX_CONFIG.minDate.toDate()}
      />
    </div>
  );
};

export default DateSearch;
